var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(0 0)",
    fill: "#fefbe8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,1A17,17,0,0,0,5.979,30.021,17,17,0,0,0,30.021,5.979,16.889,16.889,0,0,0,18,1m0-1A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z",
    transform: "translate(0 0)",
    fill: "#e5b357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.178,20.9C1.124,12.126,0,11.226,0,8A8,8,0,0,1,16,8c0,3.226-1.124,4.126-7.178,12.9a1,1,0,0,1-1.644,0ZM8,11.333A3.333,3.333,0,1,0,4.667,8,3.333,3.333,0,0,0,8,11.333Z",
    transform: "translate(10 7)",
    fill: "#efb041"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinYellow);
export default __webpack_public_path__ + "static/media/pin_yellow.7c28b95552e2a818c24a48d8509a0f55.svg";
export { ForwardRef as ReactComponent };